import { useGenericQuery } from '../../../core/api/reactQuery';
import { getPracticeExam } from '../queries';
import { auxiliarStore } from '../stores/auxiliarStore';

export function useGetPracticeAreas() {
  const { setAreas } = auxiliarStore();
  const { data, isError, isPending } = useGenericQuery(['practiceArea'], () => getPracticeExam(), setAreas);

  return {
    data,
    isError,
    isLoading: isPending
  }
}
